import './ScheduleButton.css';
import { useNavigate } from 'react-router-dom';

function ScheduleButton({ data, url, title, displayKey, routeKey, keyField }) 
{
    const navigate = useNavigate();

    if (!data || !Array.isArray(data)) return null;

    // Группируем данные по первой букве
    const groupedData = data.reduce((groups, item) => {
        const firstLetter = item[displayKey]?.charAt(0).toUpperCase() || '';
        if (!groups[firstLetter]) {
            groups[firstLetter] = [];
        }
        groups[firstLetter].push(item);
        return groups;
    }, {});

    // Сортируем буквы алфавита
    const sortedLetters = Object.keys(groupedData).sort();

    const handleItemClick = (item) => 
    {
        const routeValue = item[routeKey];
        
        navigate(`/${url}/${encodeURIComponent(routeValue)}`, 
        { 
            state: { item }
        });
    };

    return (
        <div className="teacher-schedule">
            <div className="teacher-schedule__container">
                <h2 className="teacher-schedule__title">{title}</h2>
                
                {sortedLetters.map((letter) => (
                    <div key={letter} className="teacher-group">
                        <h3 className="teacher-group__title">{letter}</h3>
                        <div className="teacher-schedule__grid">
                            {groupedData[letter].map((item) => (
                                <button 
                                    key={item[keyField]}
                                    className="teacher-schedule__button"
                                    onClick={() => handleItemClick(item)}
                                >
                                    {item[displayKey]}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ScheduleButton;